import React from 'react';
import Moment from 'moment';
import { useTranslation } from 'react-i18next';

interface Props {
  /** timestamp */
  timestamp: number;
}
/**
 * Komponent do generowania czasu czytelnego dla użytkownika
 *
 */
export default function Hour({ timestamp }: Props): JSX.Element {
  const { t } = useTranslation();

  return <span>{timestamp ? Moment(timestamp, 'X').format('L') : t('DATE_NOT_AVAILABLE')}</span>;
}
